<template>
  <div data-toggle="buttons">
    <button
      v-loading="loading"
      @click="showModal = !showModal"
      :class="{ active: innerValue.length }"
      :disabled="loading || !options.length"
      class="btn badge badge-pill text-capitalize modal-toggle"
    >
      Select TPAs ({{ options.length }})
    </button>

    <b-modal
      v-model="showModal"
      @close="setInnerValue"
      title="TPA Names"
      body-class="py-0 px-4"
      footer-class="p-4 d-flex align-items-center justify-content-between"
      class="drv-modal"
      no-close-on-backdrop
      no-close-on-esc
    >
      <VueOptionsList
        v-model="innerValue"
        v-loading="loading"
        :options="sortedOptions"
      />

      <template #modal-footer>
        <b-button
          v-if="innerValue.length"
          @click.prevent.stop="innerValue = []"
          :disabled="loading"
          variant="primary"
          outlined
          >Clear</b-button
        >
        <b-button
          @click.prevent.stop="handleSave"
          :disabled="loading"
          variant="primary"
          class="ml-auto"
          >Save</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash-es'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      innerValue: [],
      showModal: false,
      isPopulated: false
    }
  },
  computed: {
    sortedOptions() {
      return this.options.sort()
    }
  },
  methods: {
    setInnerValue(newValue) {
      if (newValue.target) this.innerValue = this.value || []
      else this.innerValue = newValue || this.value || []
    },
    handleSave() {
      this.$emit('input', this.innerValue)

      this.showModal = false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) == JSON.stringify(oldValue)) return

        this.setInnerValue(newValue)

        this.isPopulated = newValue.length ? true : false
      }
    },
    innerValue: debounce(function (newValue) {
      if (!this.isPopulated) return

      this.$emit('input', newValue)
    }, 500)
  }
}
</script>
